// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--gvj6d","label":"_02712f2b3b--label--BThBJ"};